import { useApp, useAuth } from "../../hooks";
import { Auth } from "../../layouts";

const Profile = () => {
  const { user, updateProfile } = useAuth();
  const { message } = useApp();

  return (
    <Auth.Registration
      key={user?.phone || user?.uuid || "profile"}
      initialValues={{
        ...user,
        phone:
          user?.phone || (user as any)?.mobile || (user as any)?.mobileNumber,
      }}
      onRegister={async (profile) => {
        await updateProfile(profile);
        message.success("Profile updated successfully!");
      }}
    />
  );
};

export default Profile;
